import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Signup = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleSignup = (e) => {
    e.preventDefault();
    navigate('/login');
  };

  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full max-w-[360px] mx-auto"
    >
      <div className="text-left mb-10">
        <h5 className="text-[#11469A] text-xl font-bold mb-2">Create New Account</h5>
        <p className="text-[#878a99] text-sm">Get your free RM Ghana account now.</p>
      </div>

      <form onSubmit={handleSignup} className="space-y-5">
        <div>
          <label className="block text-[13px] font-semibold text-[#212529] mb-2">Email <span className="text-red-500">*</span></label>
          <input 
            type="email" 
            placeholder="Enter email address" 
            className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px]"
            required
          />
        </div>

        <div>
          <label className="block text-[13px] font-semibold text-[#212529] mb-2">Username <span className="text-red-500">*</span></label>
          <input 
            type="text" 
            placeholder="Enter username" 
            className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px]"
            required
          />
        </div>

        <div>
          <label className="block text-[13px] font-semibold text-[#212529] mb-2">Password <span className="text-red-500">*</span></label>
          <div className="relative">
            <input 
              type={showPassword ? "text" : "password"} 
              placeholder="Enter password" 
              className="w-full px-4 py-3 rounded border border-[#ced4da] focus:border-[#00AEEF] focus:ring-2 focus:ring-[#00AEEF]/20 outline-none transition-all placeholder:text-[#adb5bd] text-[13px] pr-10"
              required
            />
            <button 
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#878a99] hover:text-[#495057]"
            >
              <SafeIcon name={showPassword ? "EyeOff" : "Eye"} size={16} />
            </button>
          </div>
        </div>

        <button 
          type="submit" 
          className="w-full bg-[#00AEEF] hover:bg-[#009bd6] text-white py-3 rounded font-semibold transition-all shadow-md mt-6 text-[13px] uppercase tracking-wider"
        >
          Sign Up
        </button>
      </form>

      <div className="mt-10 text-left">
        <p className="text-[13px] text-[#878a99]">
          Already have an account?{' '}
          <Link to="/login" className="text-[#00AEEF] font-bold hover:underline decoration-2 underline-offset-4">
            Signin
          </Link>
        </p>
      </div>
    </motion.div>
  );
};

export default Signup;